import React from 'react';

const Footer = () => {
  return (
    <footer>
      <p>© {new Date().getFullYear()} Jordan Lerat</p>
      <p>Built with React ● Styled Components ● Docker</p>
    </footer>
  );
};

export default Footer;
